export * from './LoginPage';
export * from './PartnerPage';
export * from './DocPage';
export * from './DocEditPage';
export * from './UserManager';
export * from './CompositePurchaseDocPage';


// WEBPACK FOOTER //
// ./src/pages/index.ts